import {Fancybox} from "@fancyapps/ui/dist/fancybox/";
import "@fancyapps/ui/dist/fancybox/fancybox.css";

jQuery(document).ready(function () {

   initMobileMenu();
   initPromoVideoPlayer();
   initProcessStepsAnimation();
   initTimelineAnimation();
   initFAQToggle();

});

function initMobileMenu() {
   $('.menu-toggle').on('click', function(e) {
      e.preventDefault()

      // Toggle menu visibility
      $('.main-nav').toggleClass('menu-open')
      // Toggle bottom buttons visibility
      $('.fixed-mobiles-btns-wrapper').toggleClass('menu-open')
      // Toggle icon animation
      $(this).toggleClass('menu-open')

      $('body').toggleClass('no-scroll')
   })

   // Close menu when clicking a link
   $('.main-nav .nav-menu a').on('click', function() {
      $('.main-nav, .fixed-mobiles-btns-wrapper, .menu-toggle').removeClass('menu-open')
      $('body').removeClass('no-scroll')
   })
   // Close mobile menu when clicking mobile wrapper buttons
   $('.mobile-wraps-btns .btn').on('click', function() {
      $('.main-nav, .fixed-mobiles-btns-wrapper, .menu-toggle').removeClass('menu-open')
      $('body').removeClass('no-scroll')
   })

}

function initPromoVideoPlayer() {
   const $videoContainer = $('.video-container');
   const $video = $('#promo-video');

   // Only run the execution block if the elements actually exist on the current page
   if ($video.length === 0 || $videoContainer.length === 0) {
      return;
   }

   const videoElement = $video[0];

   // Helper function to toggle play and pause states smoothly
   function toggleVideo() {
      if (videoElement.paused) {
         videoElement.play();
         $videoContainer.addClass('is-playing');
      } else {
         videoElement.pause();
         $videoContainer.removeClass('is-playing');
      }
   }

   // Event Listener: Click on the custom play button overlay
   $('.play-trigger').on('click', function(e) {
      e.stopPropagation(); // Prevents bubbling up to any container-level clicks
      toggleVideo();
   });

   // Event Listener: Click directly on the video player area
   $video.on('click', function() {
      toggleVideo();
   });

   // Event Listener: Clean up classes if the video finishes playing naturally
   videoElement.addEventListener('ended', function() {
      $videoContainer.removeClass('is-playing');
      videoElement.load(); // Reloads the video stream to restore the original poster image
   });
}

function initTimelineAnimation() {
   var $section = $('.haushaltshilfe-dauer-section');

   // Safety check: exit if the element does not exist on the page
   if (!$section.length) return;

   function checkViewport() {
      var windowHeight = $(window).height();
      var scrollTop = $(window).scrollTop();
      var elementOffset = $section.offset().top;

      // Trigger point: Start animation when the top of the element
      // enters the bottom 25% of the viewport.
      // (Increase the 0.25 to make it wait longer, or decrease to make it start sooner)
      var triggerPoint = elementOffset + (windowHeight * 0.50);

      if (scrollTop + windowHeight > triggerPoint) {
         $section.addClass('is-visible');

         // Remove event listener after triggering (animate only once)
         $(window).off('scroll.timelineSec');
      }
   }

   // Check immediately on load (in case the user jumps to the section)
   checkViewport();

   // Check on every scroll event
   $(window).on('scroll.timelineSec', checkViewport);
}

function initProcessStepsAnimation() {
   var $section = $('.process-steps-section');

   // Safety check: exit if the element does not exist on the page
   if (!$section.length) return;

   function checkViewport() {
      var windowHeight = $(window).height();
      var scrollTop = $(window).scrollTop();
      var elementOffset = $section.offset().top;

      // Trigger point: Start animation when the top of the element
      // enters the bottom 25% of the viewport.
      // (Increase the 0.25 to make it wait longer, or decrease to make it start sooner)
      var triggerPoint = elementOffset + (windowHeight * 0.45);

      if (scrollTop + windowHeight > triggerPoint) {
         $section.addClass('is-visible');

         // Remove event listener after triggering (animate only once)
         $(window).off('scroll.processSteps');
      }
   }

   // Check immediately on load (in case the user jumps to the section or refreshes)
   checkViewport();

   // Check on every scroll event (using a namespace for safety)
   $(window).on('scroll.processSteps', checkViewport);
}


function initFAQToggle(){
   $('.faq-trigger').on('click', function() {
      var $item = $(this).closest('.faq-item');
      var $content = $item.find('.faq-content');

      $('.faq-item').not($item).removeClass('is-open')
         .find('.faq-content').css('max-height', '0');

      $item.toggleClass('is-open');

      if ($item.hasClass('is-open')) {
         $content.css('max-height', $content[0].scrollHeight + "px");
      } else {
         $content.css('max-height', '0');
      }
   });
}
